import { render, staticRenderFns } from "./ListaFiliacao.vue?vue&type=template&id=55425f44"
import script from "./ListaFiliacao.vue?vue&type=script&lang=js"
export * from "./ListaFiliacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports